export const focusElementById = (id: string): void => {
    document.getElementById(id).focus();
};
